import { render } from "./AnnotationSetFilter.vue?vue&type=template&id=f73820d2&scoped=true"
import script from "./AnnotationSetFilter.vue?vue&type=script&lang=js"
export * from "./AnnotationSetFilter.vue?vue&type=script&lang=js"

import "./AnnotationSetFilter.vue?vue&type=style&index=0&id=f73820d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73820d2"]])

export default __exports__